import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';

@Injectable({
    providedIn: 'root'
})
export class ReportPDFTableHelpersService {
    drawFullCellBorder(doc: jsPDF, cell: { x: number; y: number; width: number; height: number }, lineWidth: number): void {
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(lineWidth);
        doc.rect(cell.x, cell.y, cell.width, cell.height);
    }

    drawLeftRightBorders(doc: jsPDF, cell: { x: number; y: number; width: number; height: number }, lineWidth: number): void {
        const x = cell.x;
        const y = cell.y;
        const w = cell.width;
        const h = cell.height;
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(lineWidth);
        doc.line(x, y, x, y + h);
        doc.line(x + w, y, x + w, y + h);
    }

    drawTopLeftRightBorders(doc: jsPDF, cell: { x: number; y: number; width: number; height: number }, lineWidth: number): void {
        const x = cell.x;
        const y = cell.y;
        const w = cell.width;
        this.drawLeftRightBorders(doc, cell, lineWidth);
        doc.line(x, y, x + w, y);
    }

    drawDoubleBottomLeftRightBorders(doc: jsPDF, cell: { x: number; y: number; width: number; height: number }, lineWidth: number, offset = 0.75): void {
        const x = cell.x;
        const y = cell.y;
        const w = cell.width;
        const h = cell.height;
        this.drawLeftRightBorders(doc, cell, lineWidth);
        doc.line(x, y + h - offset, x + w, y + h - offset);
        doc.line(x, y + h, x + w, y + h);
    }

    clearCellBorder(doc: jsPDF, cell: { x: number; y: number; width: number; height: number }, lineWidth: number): void {
        const x = cell.x;
        const y = cell.y;
        const w = cell.width;
        const h = cell.height;
        doc.setDrawColor(255, 255, 255);
        doc.setLineWidth(lineWidth);
        doc.line(x, y, x + w, y);
        doc.line(x, y + h, x + w, y + h);
        doc.line(x, y, x, y + h);
        doc.line(x + w, y, x + w, y + h);
    }

    writeStackedComments(doc: jsPDF, startX: number, startY: number, comments: string[], lineHeight = 5): void {
        comments.forEach((line, index) => {
            doc.text(line, startX, startY + (index * lineHeight));
        });
    }
}
